import React from "react";
import { inject } from "mobx-react";

import PageComponent from "./PageComponent";
import LoadingComponent from "~/components/LoadingComponent";
import AlertComponent from "~/components/AlertComponent";
import { ITEMS_COUNT_DEFAULT, URL_APP_APP_BASE_PATH, PREVIEW_TYPE, PAGES_PAGE_TAB, PAGES_HANGTAGS_TAB, PAGES_IMAGES_TAB, PAGES_INFOS_TAB, PAGES_FOLDERS_TAB, PAGES_TAB, PAGE_TYPE, TAGS_COLOR_DEFAULT, FONTS_COLOR_DEFAULT, PAGE_FREQUENCY, SHOW_TIME_MIDIA_DEFAULT, OPTION_TYPE, FOLDER_TYPE } from "~/configs/constants";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import Hangtags from "../DeviceModule/HangtagsTab";
import { dateFormat, isEmptyOrNullStr } from '../../helpers/utils'
import Images from "../DeviceModule/ImagesTab";
import Infos from "../DeviceModule/InfosTab";
import Folders from "../DeviceModule/FoldersTab";
import { getVarFromUrl } from "../../helpers/utils";

@inject("PageStore", "DeviceStore", "FileStore", "FontStore", "PreviewStore")
class PageContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: PAGES_PAGE_TAB,
      isLoading: true,
      searchText:"",
      page: {}
    };
  }

  async componentDidMount() {
    await this.getPage();

    try {
      const { font } = this.state;
      document.getElementById("font").style.fontFamily = font.name;
    } catch{}
  }

  getPage = async () => {
    const { activeTab } = this.state;

    this.setState({
      isLoading: true,
    });
    
    const { PageStore, DeviceStore } = this.props;

    let deviceId = getVarFromUrl("deviceId");
    let device = await DeviceStore.getDeviceById(deviceId);
    const pageId = getVarFromUrl("pageId");
    const tab = getVarFromUrl("tab");

    let page = {};
    page.deviceId = deviceId;
    page.type = PAGE_TYPE.tags;
    page.order = 0;
    page.tagsColor = TAGS_COLOR_DEFAULT;
    page.fontColor = FONTS_COLOR_DEFAULT;
    page.frequency = PAGE_FREQUENCY.fixed;
    page.durationTimer = SHOW_TIME_MIDIA_DEFAULT;
    page.folderType = FOLDER_TYPE.type1;
    page.itemsCount = ITEMS_COUNT_DEFAULT;

    if (pageId !== undefined && parseInt(pageId) > 0){
      page = await PageStore.getPage(pageId);
      deviceId = page.deviceId;
    }

    if (isEmptyOrNullStr(page.daysOfWeek)) page.daysOfWeek = "[]";
    if (isEmptyOrNullStr(page.startDate)) page.startDate = dateFormat(new Date());
    if (isEmptyOrNullStr(page.endDate)) page.endDate = dateFormat(new Date());

    let layouts = await this.getLayouts("", page, device);   
    let layout = await this.getLayout(layouts, page);
    
    let fonts = await this.getFonts("");   
    let font = await this.getFont(fonts, page);    
    let canPreview = (page?.pageId > 0 && page?.type !== PAGE_TYPE.info && page?.type !== PAGE_TYPE.midia);
    this.setState({
      activeTab: (tab !== undefined  && tab !== null ? tab : activeTab),
      page,
      device,
      layouts,
      layout,
      fonts,
      font,
      isLoading: false,
      canPreview,
      originalType: page.type
    });
  };

  getLayouts = async (filter, page, device) => {
    const { FileStore } = this.props
    let layouts = [];
    let layoutsData = await FileStore.getDesigns(filter, device.orientation);
    let hasDesign = (page.design !== undefined && page.design !== null && page.design.id > 0);
    let designId = 0;
    if (hasDesign) designId = page.design.id;
    let designFound = false;
    for (let i = 0; i < layoutsData.length; i++) {
      if (layoutsData[i].id === designId) designFound = true;
      layouts.push(
      {
        id: layoutsData[i].id,
        url: layoutsData[i].url,
        name: layoutsData[i].name.replace(".jpg",""),
        label: layoutsData[i].name.replace(".jpg",""),
        type: OPTION_TYPE.layout
      });
    }

    if (hasDesign && !designFound)
      layouts.push(
      {
        id: page.design.id,
        url: page.design.url,
        name: page.design.name.replace(".jpg",""),
        label: page.design.name.replace(".jpg",""),
        type: OPTION_TYPE.layout
      });

    return layouts;   
  };

  getLayout = async (layouts, page) => {
    let layout = {};
    if (layouts !== undefined && layouts !== null && layouts.length > 0) layout = layouts[0];
    for (var i = 0; i < layouts.length; i++){
      if (layouts[i].url === page.layoutLinkUrl){
        layout = layouts[i];
        break;
      }
    }; 
    return layout;
  };

  getFonts = async (filter) => {
    const { FontStore } = this.props
    let fonts = [];
    let fontsData = await FontStore.getFonts(filter);
    for(let i = 0; i < fontsData.length; i++) {
      this.cssFontFaceMidia(fontsData[i].name, fontsData[i].url);
      fonts.push(
        {
          id: fontsData[i].fontId,          
          name: fontsData[i].name,
          label: fontsData[i].name,
          cssName: fontsData[i].cssName,
          url: fontsData[i].url,
          type: OPTION_TYPE.font
        }
      );
    }
    return fonts;   
  };

  cssFontFaceMidia = (name, url) => {     
    var existingStyles = document.querySelectorAll("style");
    var fontExists = false;
    
    existingStyles.forEach((style) => {
      if (style.innerHTML.includes(`font-family: '${name}'`)) {
        fontExists = true;
      }
    });
    
    if (fontExists) return;

    var newStyle = document.createElement('style');
    newStyle.appendChild(document.createTextNode(`\
    @font-face {\
      font-family: '${name}';\
      src: url('${url}');\
    }\
    `));
    document.head.appendChild(newStyle);    
  };

  getFont = async (fonts, page) => {
    let font = {};
    if (fonts !== undefined && fonts !== null && fonts.length > 0) font = fonts[0];
    for (var i = 0; i < fonts.length; i++){
      if (fonts[i].id === page.fontId){
        font = fonts[i];
        break;
      }
    }; 
    return font;
  };

  goDevice = () => {
    const { page } = this.state;
    const { history } = this.props;    
    history.push(`device?deviceId=${page.deviceId}&tab=${PAGES_TAB}`);
  };

  goPage = () => {
    const { page } = this.state;
    const { history } = this.props;
    history.push(`page?deviceId=${getVarFromUrl("deviceId")}&pageId=${page.pageId}&tab=${PAGES_PAGE_TAB}`);
  };

  maintainPage = async () => {
    this.setState({
      isLoading: true
    });

    const { page } = this.state;
    const { PageStore } = this.props;

    let itemsCount = Number(page.itemsCount);
    if ((itemsCount === 0 || itemsCount < 1 || isNaN(itemsCount))) {
      page.itemsCount = 1;
    }
   
    const result = await PageStore.update(page);
    if (result && result?.pageId > 0){
      this.setState({
        page: result
      });
      AlertComponent.success("Página salva com sucesso");
      PageStore.setPageId(result?.pageId);
      this.goPage();
    } else {
      AlertComponent.error("Falha ao salvar página");
    }    
    this.setState({
      isLoading: false
    });
  };

  onChange = (e) => {
    const { page } = this.state;
    let { name, value } = e.target;

    if (name === "itemsCount") {
      value = Number(value);
      if ((value === 0 || value < 1 || isNaN(value))) {
        value = "";
      }
    }

    const updatedPage = {
      ...page,
      [name]: value
    } 
    
    this.setState({
      page: updatedPage,
    });
  };

  onChangeLayout = (layoutItem) => {
      const { page, layout } = this.state; 
      if (layoutItem === null || layoutItem === undefined) layoutItem = layout;

      page.layoutLinkUrl = layoutItem.url;
      this.setState({
        layout: layoutItem,
        page: page
      }); 
  };

  onKeyUpLayout = async (filter) => {
    try {
      this.setState({
        layoutIsLoading: true,
      });
      const { device } = this.state; 
      const { page } = this.state;
      let layouts = await this.getLayouts(filter, page, device);
      this.setState({
        layouts,
      });
      this.setState({
        layoutIsLoading: false,
      });
    }
    catch {}
  };

  onChangeColor = (color) => {
    const { page } = this.state;  
    page.color = color.hex;
    this.setState({
      page: page,
    });
  };

  onChangeTagsColor = (color) => {
    const { page } = this.state;  
    page.tagsColor = color.hex;
    this.setState({
      page: page,
    });
  };
  
  onChangeFontColor = (color) => {
    const { page } = this.state;  
    page.fontColor = color.hex;
    this.setState({
      page: page,
    });
  };

  onChangeFont = (fontItem) => {
    try {
      const { page } = this.state;
      page.fontId = fontItem.id;
      document.getElementById("font").style.fontFamily = fontItem.name;
      this.setState({
        font: fontItem,
        page: page
      });       
    } catch {}
  };

  onKeyUpFont = async () => {
    try {
      this.setState({
        fontIsLoading: true,
      });   
      let filter = document.getElementById("font").value;
      let fonts = await this.getFonts(filter);
      this.setState({
        fonts,
      });
      this.setState({
        fontIsLoading: false,
      });
    }
    catch {}
  }; 

  onChangePeriod = (value,) => {
    const { page } = this.state;
    page.startDate = dateFormat(value[0]);
    page.endDate = dateFormat(value[1]);
    this.setState({
      page: page
    });
  };

  onChangeDaysOfWeek = (event, value) => {
    const { page } = this.state;
    page.daysOfWeek = JSON.stringify(value);
    this.setState({
      page: page
    });
  };

  tabPageToggle = (tab) => {
    this.preview();
    const { activeTab } = this.state;
    if (activeTab === tab) return;
    this.setState({
      activeTab: tab,
    });
  };

  preview = async () => {
    try {
      setTimeout(async() => {
        const iframe = document.getElementById("tagPreview");
        const fallback = document.getElementById("fallback");        
        const loader = document.getElementById("loader");
        const { page, canPreview, originalType } = this.state;
        const { PreviewStore } = this.props;        
        const deviceId = getVarFromUrl("deviceId");
        const pageId = getVarFromUrl("pageId");

        if (pageId === 0) return; 
        
        if (!canPreview || page.type !== originalType){
          if (iframe) iframe.style.opacity = 0;
          if (fallback) fallback.style.display = "flex";
          return;
        }

        fallback.style.display = "none";
        loader.style.display = "flex";
        iframe.style.opacity = 0;        

        let preview = {};
        preview.payload = JSON.stringify(page);
        preview.type = PREVIEW_TYPE.page;
        preview.deviceId = deviceId;
        preview.pageId = pageId === 0 ? null : pageId;
        preview = await PreviewStore.add(preview);
        
        const path = URL_APP_APP_BASE_PATH + "?preview=" + preview.previewId.toString();

        iframe.src = path;

        window.addEventListener("message", (event) => {
          if (event.data.msg === "PREVIEW_READY") {
            iframe.style.transition = "opacity 0.5s ease";
            iframe.style.opacity = 1;
            loader.style.display = "none";
            fallback.style.display = "none";
          }
        });
      }, 0);
    } catch {}
  };

  render() {
    const { isLoading, page, layouts, layout, activeTab, layoutIsLoading, fontIsLoading, font, fonts, device, canPreview } = this.state;
    const { history } = this.props;
    const canDelete = page?.pageId > 0;
    return (
      <>
      <div className="content content-xs" style={{overflow: "hidden"}}>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === PAGES_PAGE_TAB })}
              onClick={() => {
                this.tabPageToggle(PAGES_PAGE_TAB);
              }}
            >
              Página
            </NavLink>
          </NavItem>
          {canDelete && (page.type === PAGE_TYPE.tags || page.type === PAGE_TYPE.list || page.type === PAGE_TYPE.table) ? (
            <>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === PAGES_HANGTAGS_TAB })}
                  onClick={() => {
                    this.tabPageToggle(PAGES_HANGTAGS_TAB);
                  }}
                >
                  Etiquetas
                </NavLink>
              </NavItem>
            </>
            ): null }
          {canDelete && (page.type === PAGE_TYPE.midia) ? (     
            <>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === PAGES_IMAGES_TAB })}
                  onClick={() => {
                    this.tabPageToggle(PAGES_IMAGES_TAB);
                  }}
                >
                  Mídias
                </NavLink>
              </NavItem>
            </>      
          ): null }
          {canDelete && (page.type === PAGE_TYPE.info) ? (     
            <>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === PAGES_INFOS_TAB })}
                  onClick={() => {
                    this.tabPageToggle(PAGES_INFOS_TAB);
                  }}
                >
                  Informativos
                </NavLink>
              </NavItem>
            </>      
          ): null }
          {canDelete && (page.type === PAGE_TYPE.folder) ? (     
            <>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === PAGES_FOLDERS_TAB })}
                  onClick={() => {
                    this.tabPageToggle(PAGES_FOLDERS_TAB);
                  }}
                >
                  Cartazes
                </NavLink>
              </NavItem>
            </>      
          ): null }
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={PAGES_PAGE_TAB}>
            {(isLoading && (
              <>
                <LoadingComponent />
              </>
            )) || (
                <PageComponent
                  page={page}
                  onClick={this.maintainPage}
                  onCancel={this.goDevice}
                  onChange={this.onChange}
                  layout={layout}
                  layouts={layouts}
                  onChangeLayout={this.onChangeLayout}
                  layoutIsLoading={layoutIsLoading}
                  onKeyUpLayout={this.onKeyUpLayout}
                  onChangeColor={this.onChangeColor}
                  onChangeTagsColor={this.onChangeTagsColor}
                  onChangeFontColor={this.onChangeFontColor}
                  fontIsLoading={fontIsLoading}
                  onKeyUpFont={this.onKeyUpFont}
                  onChangeFont={this.onChangeFont}
                  fonts={fonts}
                  font={font}
                  calendarMinDate={new Date()}
                  onChangePeriod={this.onChangePeriod}
                  onChangeDaysOfWeek={this.onChangeDaysOfWeek}
                  orientation={device.orientation}
                  canPreview={canPreview}
                  preview={this.preview}
                />
            )}
          </TabPane>
          {canDelete && (page.type === PAGE_TYPE.tags || page.type === PAGE_TYPE.list || page.type === PAGE_TYPE.table) ? (
          <TabPane tabId={PAGES_HANGTAGS_TAB}>
            <Hangtags history={history} />
          </TabPane>
          ): null }
          {canDelete && (page.type === PAGE_TYPE.midia) ? ( 
          <TabPane tabId={PAGES_IMAGES_TAB}>
            <Images history={history} />
          </TabPane>
          ): null }
          {canDelete && (page.type === PAGE_TYPE.info) ? ( 
          <TabPane tabId={PAGES_INFOS_TAB}>
            <Infos history={history} />
          </TabPane>
          ): null }
          {canDelete && (page.type === PAGE_TYPE.folder) ? (
            <TabPane tabId={PAGES_FOLDERS_TAB}>
              <Folders history={history} />
            </TabPane> 
          ): null }
        </TabContent>
      </div> 
      </>
    );
  }
}

export default PageContainer;